import { render, staticRenderFns } from "./ed-collaborative-text-editor.vue?vue&type=template&id=2e28cc98&"
import script from "./ed-collaborative-text-editor.ts?vue&type=script&lang=ts&"
export * from "./ed-collaborative-text-editor.ts?vue&type=script&lang=ts&"
import style0 from "./ed-collaborative-text-editor.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/styles/quill.snow.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports